package com.artvending.warden

import androidx.compose.runtime.*
//import androidx.compose.ui.unit.dp
import kotlinx.datetime.LocalDateTime
import kotlin.math.ceil
import kotlin.math.max
import kotlin.math.min

enum class TimelineUnitMode {
	EMPTY,
	WORKING_TIME,
	FIXED_TIME,
	LATE
}

class TimelineUnit(val time: Int, val mode: TimelineUnitMode) {
	var width by mutableStateOf(0f)
	
	companion object {
		fun createUnits(currentDateTime: LocalDateTime): List<TimelineUnit> {
			val units = mutableListOf<TimelineUnit>()
			
			var todayWorkingTime = todayWorkingTime
			
			if (todayWorkingTime == null)
				todayWorkingTime = TimeInterval(510, 1020)
			
			val workingTimeFrom = todayWorkingTime.from
			val workingTimeTo = todayWorkingTime.to
			
			if (workingTimeFrom == null || workingTimeTo == null)
				return units
			
			val fixedIntervalFrom = fixedInterval?.from
			val fixedIntervalTo = fixedInterval?.to
			val startMinutes = if (fixedIntervalFrom == null) workingTimeFrom else min(workingTimeFrom, fixedIntervalFrom)
			val endMinutes = (if (fixedIntervalTo == null) workingTimeTo else max(workingTimeTo, fixedIntervalTo)) - 10
			val startUnitMinutes = startMinutes / 10 * 10
			val endUnitMinutes = ceil(endMinutes.toDouble() / 10.0) * 10
			var currentUnitMinutes = startUnitMinutes
			val currentMinutes = currentDateTime.getDayMinutes()
			
			while (currentUnitMinutes < endUnitMinutes + 10) {
				val filled = fixedIntervalFrom != null && (fixedIntervalFrom < currentUnitMinutes + 10 && (if (fixedIntervalTo == null) currentMinutes > currentUnitMinutes else fixedIntervalTo > currentUnitMinutes))
				units.add(
					TimelineUnit(
						currentUnitMinutes,
						if (filled)
							TimelineUnitMode.FIXED_TIME
						else
							if ((fixedIntervalFrom ?: currentMinutes) > currentUnitMinutes)
								TimelineUnitMode.LATE
							else
								TimelineUnitMode.WORKING_TIME
					)
				)
				currentUnitMinutes += 10
			}
			
			val lastUnit = units.lastOrNull()
			
			if (lastUnit != null) {
				while ((currentUnitMinutes) % 60 != 0) {
					units.add(TimelineUnit(currentUnitMinutes, TimelineUnitMode.EMPTY))
					currentUnitMinutes += 10
				}
			}
			
			val firstUnit = units.firstOrNull()
			
			if (firstUnit != null) {
				currentUnitMinutes = firstUnit.time
				
				while (currentUnitMinutes % 60 != 0) {
					currentUnitMinutes -= 10
					units.add(0, TimelineUnit(currentUnitMinutes, TimelineUnitMode.EMPTY))
				}
			}
			
			return units
		}
	}
}